import { createClient } from "~/lib/supabase";

/**
 * Returns Authorization header with the current Supabase access token, or an
 * empty object if the visitor is anonymous. Use for tier-aware public
 * endpoints that should still receive the bearer token when the user is
 * logged in (e.g. financials summary, score).
 */
export async function authHeaders(): Promise<Record<string, string>> {
	if (typeof window === "undefined") return {};
	try {
		const {
			data: { session },
		} = await createClient().auth.getSession();
		if (!session?.access_token) return {};
		return { Authorization: `Bearer ${session.access_token}` };
	} catch {
		return {};
	}
}
